import { is2xxStatus } from './AlertMessageLogic'

export default function messageOnRemoveRule(status) {
    let message

    if (is2xxStatus(status)) status = '2xx'

    switch (status) {
        case 503:
            message = 'Ops! Ocorreu um problema com a internet e não conseguimos remover a Rule.'
            break
        case '2xx':
            message = 'Removemos a Rule.'
            break
        case 401:
            message = 'Ops! O seu tempo de acesso expirou, para remover a Rule é necessário realizar o login.'
            break
        case 403:
            message = 'Permissão Negada.'
            break
        case 500:
        default:
            message = 'Ops! Algo estranho ocorreu e não removemos a Rule. Por favor, tente novamente mais tarde.'
    }
    return message
}
